var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "FilterManagerParent",
        { on: { exportExcel: _vm.handleExportExcel } },
        [_c("TableDataManagerParent", { ref: "dataParent" })],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }